import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useValueRef } from '@cian/react-utils';
import { useDropdownController, useFocusOptionController } from '../../../internal/hooks/controllers';
import { SELECT_ALL_INDEX } from '../../../internal';
export function useMultiSelectDesktopController(props) {
  const {
    open,
    actions: dropdownActions
  } = useDropdownController(props);
  const {
    focusedIndex,
    actions: focusOptionActions
  } = useFocusOptionController({
    length: props.options.length,
    minIndex: props.allOption ? SELECT_ALL_INDEX : 0
  });
  const stateRef = useValueRef({
    props,
    open,
    focusedIndex
  });
  const allOptionLabel = React.useMemo(() => {
    if (!props.allOption) {
      return;
    }
    return typeof props.allOption === 'boolean' ? 'Выбрать всё' : props.allOption;
  }, [props.allOption]);
  React.useEffect(() => {
    const {
      options,
      value
    } = stateRef.current.props;
    if (open) {
      return;
    }
    const firstIndex = props.allOption ? SELECT_ALL_INDEX : 0;
    const firstSelectedIndex = props.allOption && value.length === options.length ? SELECT_ALL_INDEX : options.findIndex(option => value.includes(option.value));
    focusOptionActions.setFocusedIndex(Math.max(firstSelectedIndex, firstIndex));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, props.allOption]);
  const setFocusedOptionState = nextState => {
    const {
      props,
      focusedIndex
    } = stateRef.current;
    const option = props.options[focusedIndex];
    if (!option) {
      return;
    }
    const optionValue = option.value;
    const prevValue = props.value;
    const isChecked = prevValue.includes(optionValue);
    if (isChecked === nextState) {
      return;
    }
    if (nextState) {
      props.onChange([...prevValue, optionValue]);
    } else {
      props.onChange(prevValue.filter(v => v !== optionValue));
    }
  };
  const toggleAllOptionState = () => {
    const {
      props
    } = stateRef.current;
    const allValues = props.options.map(option => option.value);
    const newValue = props.value.length === props.options.length ? [] : allValues;
    props.onChange(newValue);
  };
  const toggleOptionState = index => {
    const {
      props
    } = stateRef.current;
    const option = props.options[index];
    if (!option) {
      return;
    }
    const optionValue = option.value;
    const prevValue = props.value;
    const isChecked = prevValue.includes(optionValue);
    if (isChecked) {
      props.onChange(prevValue.filter(v => v !== optionValue));
    } else {
      props.onChange([...prevValue, optionValue]);
    }
  };
  const toggleFocusedOptionState = () => {
    const {
      focusedIndex
    } = stateRef.current;
    if (focusedIndex === SELECT_ALL_INDEX) {
      toggleAllOptionState();
    } else {
      toggleOptionState(stateRef.current.focusedIndex);
    }
  };
  const actions = _objectSpread(_objectSpread(_objectSpread({}, dropdownActions), focusOptionActions), {}, {
    setFocusedOptionState,
    toggleFocusedOptionState,
    toggleOptionState,
    toggleAllOptionState
  });
  return {
    open,
    focusedIndex,
    actions,
    allOptionLabel
  };
}